module.exports = {
	"header": "Encan",
	"auctions": "Encans",
	"cancelled": "Cet encan a été annulé.",
	"amount": "Montant",
	"category": "Catégorie",
	"created": "Encan créé",
	"date": "Date d'encan",
	"end": "Date de fin de l'encan",
	"imageAlt": "$t(general::userSubmitted) pour représenter l'encan",
	"listauctions": "Liste des encans",
	"location": "Emplacement de l'encan",
	"noAuctions": "Aucun encan.",
	"ongoing": "L'encan est en cours.",
	"notOngoing": "Cet encan n'est pas en cours. Il est peut-être terminé.",
	"over": "L'encan est terminé.",
	"status": {
		"cancelled": "Annulé",
		"finished": "Terminé",
		"ongoing": "En cours",
		"unpublished": "Non publié",
		"upcoming": "À venir"
	},
	"fullStatus": {
		"cancelled": "Encan annulé",
		"cancelled_plural": "Encans annulés",
		"finished": "Encan terminé",
		"finished_plural": "Encans terminés",
		"live": "Encan en cours",
		"live_plural": "Encans en cours",
		"unpublished": "Encan non publié",
		"unpublished_plural": "Encans non publiés",
		"upcoming": "Encan à venir",
		"upcoming_plural": "Encans à venir"
	},
	"shareThis": "Partager cet encan",
	"unpublished": "L'encan n'a pas encore été publié. Essayez de nouveau plus tard.",
	"bidMode": {
		"none": "Sans offres",
		"noneDescription": "Les pré-offres ne seront pas activées pour cet encan. L'encan va seulement afficher l'information sur les lots et les photos.",
		"standard": "Encan standard",
		"standardDescription": "Les enchérisseurs pourront envoyer des mises régulières et maximales pour chaque lot. Le meneur de l'enchère et le nombre de mises seront affichés sur la page de chaque lot.",
		"silent": "Encan silencieux",
		"silentDescription": "Les enchérisseurs pourront envoyer des mises sur les lots. Aucune information ne sera affichée sur qui est le meneur ou le nombre de mises sur la page de chaque lot."
	},
	"catalog": {
		"bidNow": "Enchérir maintenant",
		"description": "Description",
		"empty": "L'encan n'a pas de lot.",
		"endOfCatalog": "Fin du catalogue",
		"increments": "Incréments",
		"joinLive": "Joindre l'encan en temps réel",
		"location": "Emplacement",
		"noDescription": "Aucune description pour ce lot",
		"noPicture": "Aucune photo pour ce lot",
		"picture": "Photo",
		"registerForThisAuction": "S'enregistrer pour enchérir dans cet encan",
		"sellerId": "ID d'encanteur",
		"subheaderCatalog": "Catalogue de l'encan",
		"subheaderInformation": "Encan du",
		"unwatchThisAuction": "Ne plus suivre cet encan",
		"unwatchThisLot": "Ne plus suivre ce lot",
		"userRequestSent": "Demande envoyée",
		"watchThisAuction": "Suivre cet encan",
		"watchThisLot": "Suivre ce lot"
	},
	"lot": {
		"auctionInformation": "Information sur l'encan",
		"bid": "Enchérir",
		"bidAmount": "Montant de l'offre",
		"bidding": "Enchères",
		"biddingNotStarted": "Les pré-offres n'ont pas encore commencé. Elles vont démarrer le __startTime__",
		"biddingOver": "Les pré-offres pour cet encan sont maintenant terminées.",
		"bidRegistered": "Votre offre de __amount__ a été enregistrée.",
		"bids": "Offres",
		"bidTypes": {
			"automatic": "Enchère automatique",
			"liveOnline": "Enchère en ligne en temps réel",
			"liveOnsite": "Enchère sur place en temps réel",
			"preBid": "Pré-offre",
			"unknown": "Type d'enchère inconnu"
		},
		"currency": "Devise",
		"ended": "S'est terminé le",
		"ending": "Se termine dans",
		"endTime": "Date de fin pour les pré-offres",
		"enterBid": "Saisir une offre",
		"enterMaximumBid": "Saisir une offre maximale",
		"enterOrMore": "Entrez __amount__ ou plus",
		"incrementsTable": "Table d'incréments",
		"key": "Étiquette",
		"leadingBid": "Offre en tête",
		"logInToBid": "Veuillez vous connecter ou enregistrez-vous pour miser dans cet encan...",
		"lot": "lot",
		"lotDetails": "Détails du lot",
		"lotDetailsHelp": {
			"example": "Par exemple, si le lot est un véhicule, vous pouvez utiliser 'Kilométrage' comme étiquette et '123 456' comme valeur.",
			"explanation": "Ici vous pouvez ajouter des spécifications ou des propriétés pour votre lot dans le but de donner plus de contexte à vos acheteurs potentiels."
		},
		"lots": "lots",
		"lotsListed": "lots listés",
		"makeBid": "Faire une offre",
		"maximumBid": "Offre maximale",
		"makeMaximumBid": "Faire une offre maximale",
		"maximumBidAmount": "Montant de l'offre maximale",
		"nextLot": "Lot suivant",
		"notBidded": "Vous n'avez pas enchéri sur ce lot.",
		"noMaximumSet": "Vous n'avez pas soumis d'enchère maximale.",
		"nowLeadingBid": "Votre offre est en tête.",
		"overBidded": "Votre offre a été surpassée! Saisir une nouvelle offre.",
		"paymentAndPremiums": "Paiement et primes",
		"previousLot": "Lot précédent",
		"standardBid": "Offre régulière",
		"startingBid": "Enchère de départ",
		"switchInstant": "Changer pour offre instantanée",
		"switchMaximum": "Changer pour offre maximale",
		"timeLeft": "Temps restant",
		"value": "Valeur",
		"youHaveBidded": "Vous avez enchéri",
		"youHaveLeadingBid": "Vous être le meneur de l'enchère.",
		"youHaveMaximum": "Vous avez soumis un maximum jusqu'à"
	},
	"defaultStartingBid": "Enchère de départ par défaut",
	"preBiddingEndDate": "Date de fin des pré-offres",
	"preBiddingStartDate": "Date de début des pré-offres"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/auction.json5
// module id = 1970
// module chunks = 6